export default {
  labels: {
    selectOne: 'Выберите один вариант',
    selectAll: 'Выберите все подходящие варианты',
    typeResponse: 'Введите свой ответ в текстовое поле ниже.',
    recordResponse: 'Запишите ответ, чтобы ответить на вопрос.',
    enterNumeric: 'Введите числовой ответ в поле ниже.',
    rateResponseScale: 'Оцените свой ответ по предоставленной шкале.',
    sliderMinimum: 'Минимальное значение: {value}',
    sliderMaximum: 'Максимальное значение: {value}',
    selectOneOptionRow: 'Выберите один вариант в каждой строке.',
    selectAllOptionsRow: 'Выберите все подходящие варианты в каждой строке.',
    dragAndDropResponse: 'Перетащите варианты, чтобы расставить их в порядке предпочтения.',
    rankOrderDesktopInstruction: 'Перетаскивайте элементы для их ранжирования или используйте кнопку +, чтобы добавить элемент. Используйте кнопки со стрелками для изменения порядка или кнопку удаления для удаления элемента.',
    alert: "Предупреждение",
    error: 'Пожалуйста, введите число от {min} до {max}.',
    cameras: 'Камеры',
    microphones: 'Микрофоны',
    recording: 'Запись',
    noDevicesFound: 'Устройства не найдены',
    camera: 'Камера',
    microphone: 'Микрофон',
    stopRecording: 'Остановить запись',
    startRecording: 'Начать запись',
    disableCamera: 'Отключить камеру',
    enableCamera: 'Включить камеру',
    disableMicrophone: 'Отключить микрофон',
    enableMicrophone: 'Включить микрофон',
    settings: 'Параметры',
    recordingProgress: 'Ход записи',
    playbackProgress: 'Ход воспроизведения',
    play: 'Проигрывать',
    pause: 'Пауза',
    stop: 'Стоп',
    record: 'Записать',
    recordAgain: 'Записать снова',
    retry: 'Повторить',
    done: 'Готово',
    minRecordTime: 'Пожалуйста, запишите ответ в течение {min} секунд.',
    enlargeImage: 'Увеличить изображение',
    enlargedImage: 'Увеличенное изображение',
    close: 'Закрыть',
    zoomIn: 'Увеличить',
    zoomOut: 'Уменьшить',
    resetZoom: 'Сбросить масштаб',
    zoomLevel: 'Масштаб {percentage}%',
    imagePosition: '{current} из {total}',
    previousImage: 'Предыдущее изображение',
    nextImage: 'Следующее изображение',
    imageLoading: 'Загрузка изображения',
    imageLoadFailed: 'Не удалось загрузить изображение',
  },
  noSelection: "Ничего не выбрано",
  actions: {
    increase: 'Увеличить',
    decrease: 'Уменьшить'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Предпросмотр Опроса Завершён',
      titleCompleted: 'Предпросмотр Опроса Завершён Успешно',
      previewModeWarning: 'Эта страница видна только в режиме предпросмотра и не будет показана реальным респондентам.',
      reachedEndPoint: 'Этот опрос достиг конечной точки.',
      reachedEndPointCompleted: 'Этот предпросмотр достиг конечной точки.',
      returnToModify: 'Вернитесь к предыдущему вопросу, чтобы изменить ответы и протестировать другой путь опроса.',
      logic: 'Логика'
    }
  }
}
